/**
 * Alexander Prinz – Einstieg (ES-Modul, gebündelt mit esbuild)
 * Jedes Modul exportiert init() und kümmert sich selbst um seine DOM-Abfrage.
 */
import { onReady } from './utils/dom.js';
import * as inputModality from './modules/input-modality.js';
import * as viewport from './modules/viewport.js';
import * as services from './modules/services.js';
import * as partners from './modules/partners.js';
import * as header from './modules/header.js';
import * as menu from './modules/menu.js';
import * as hero from './modules/hero.js';
import * as reveal from './modules/reveal.js';
import * as scrollspy from './modules/scrollspy.js';
import * as skipLink from './modules/skip-link.js';
import * as anchors from './modules/anchors.js';
import * as contactForm from './modules/contact-form.js';

document.documentElement.classList.add('js');
document.documentElement.classList.remove('no-js');
inputModality.init();
viewport.init();   // sofort, vor dem ersten Scrollen

onReady(() => {
	header.init();
	menu.init();
	hero.init();
	partners.init();   // vor reveal: Einblend-Stufen passen dann zur neuen Reihenfolge
	reveal.init();
	services.init();
	scrollspy.init();
	skipLink.init();
	anchors.init();
	contactForm.init();
});
